import { render, staticRenderFns } from "./message_receive.vue?vue&type=template&id=6feb8af0&scoped=true&"
import script from "./message_receive.vue?vue&type=script&lang=ts&"
export * from "./message_receive.vue?vue&type=script&lang=ts&"
import style0 from "./message_receive.vue?vue&type=style&index=0&id=6feb8af0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feb8af0",
  null
  
)

export default component.exports